import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { setModal, selectModal } from "../../../redux/modalSlice";
import { selectDropdowns, selectDropdownOptions } from '../../../redux/dropdownSlice'
import { useForm, Controller } from 'react-hook-form'
import Select from 'react-select'
import { reactSelectClassNames } from '../../../helpers/react-select-styles'
import { useRequest } from '../../../hooks/UseRequest'
import { setNotification } from '../../../redux/notificationSlice'
import { selectPaymentScheduleData } from "../../../redux/paymentScheduleDataSlice";
import SpecialInstruction from '../../../components/elements/SpecialInstruction'
import { useNavigate } from "react-router-dom"

export default function VoidLoanModal() {
  const dispatch = useDispatch();
  const modal = useSelector(selectModal);
  const dropdowns = useSelector(selectDropdowns);
  const dropdownOptions = useSelector(selectDropdownOptions);
  const paymentScheduleData = useSelector(selectPaymentScheduleData)
  const customerId = modal.options?.customerId
  const loanId = modal.options?.loanId
  const navi = useNavigate()

  const voidLoanReason = dropdowns.data.filter((o) => o.code_key === 'void_reason')[0];
  const voidLoanReasonOptions = dropdownOptions.filter((o) => o.dropdown_id === voidLoanReason?.id).map((o) => ({ label: o.name, value: o.id, codeKey: o.code_key }));

  const { register, handleSubmit, control, watch, setValue, formState: { errors }, reset } = useForm();
  const [saving, setSaving] = useState(false)
  const request = useRequest()

  useEffect(() => {
    if (modal.options?.customerId && modal.type === 'void_loan_modal') {
      reset({ void_reason_dropdown_option_id: '' });
    }
  }, [modal.options?.customerId])

  const handleCancel = () => {
    reset({ void_reason_dropdown_option_id: '' });
    dispatch(setModal({ is_active: false }));
  };

  const onSubmit = async (formData) => {
    setSaving(true)
    request.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/customer/${customerId}/payment_schedule/void`)
    try {
      formData.void_reason_dropdown_option_id = formData.void_reason_dropdown_option_id.value;

      if (paymentScheduleData?.paymentScheduleCurrentDate !== null) {
        formData.current_date = paymentScheduleData?.paymentScheduleCurrentDate;
      }

      if (loanId) {
        formData.loan_id = loanId;
      }

      const response = await request.modify(formData)
      if (response.status === 200 || response.status === 201) {
        setSaving(false)
        dispatch(setNotification({ type: 'success', body: '' }))
        modal.options?.successCallback()
        handleCancel()

        // reload the page
        const pathSegments = window.location.pathname.split('/');
        const moduleName = pathSegments[1];
        setTimeout(() => navi(`/${moduleName}/${customerId}`, { state: { reloadPage: true } }), 2000);
      } else {
        setSaving(false)
        dispatch(setNotification({ type: 'error', body: `Error: ${response.status}` }))
      }
    } catch (error) {
      setSaving(false)
      const errorMessage = error?.response?.data?.message ?? error?.response?.data?.messageExtreme
      dispatch(setNotification({ type: 'error', body: errorMessage }))
    }
  };

  return modal.is_active && modal.type === 'void_loan_modal' ? (
    <form onSubmit={handleSubmit(onSubmit)} id="void_loan_modal_form">
      <div className="modal is-active">
        <div className="modal-background"></div>
        <div className="modal-card column is-7">
          <header className="modal-card-head py-3">
            <p className="modal-card-title is-capitalized">
              Void Loan
            </p>
            <button className="delete" aria-label="close" onClick={handleCancel}></button>
          </header>
          <section
            className="modal-card-body modal-card-body pt-1 pb-1"
            style={{ minHeight: "110px", overflow: 'hidden' }}
          >
            <div className="columns mb-0 is-flex-direction-column">
              <div className="column">
                <h3 className="has-text-danger">Use this action when your intention is to VOID the loan.</h3><br />
                <h3>Select Reason <span className="has-text-danger">*</span></h3>

                <Controller
                  name="void_reason_dropdown_option_id"
                  control={control}
                  rules={{ required: "Please select a reason" }}
                  render={({ field }) => {
                    return (
                      <Select
                        {...field}
                        options={voidLoanReasonOptions}
                        isSearchable={false}
                        classNames={reactSelectClassNames(errors, 'void_reason_dropdown_option_id')}
                        menuPosition="fixed"
                        styles={{ container: (base) => ({ ...base, width: '100%' }), menu: ({ ...css }) => ({ ...css, width: '100%' }) }}
                        onChange={(val) => field.onChange({ label: val?.label, value: val?.value })}
                        form="void_loan_modal_form"
                      />
                    )
                  }}
                />
                {errors?.void_reason_dropdown_option_id?.message && <p className="has-text-danger">{errors?.void_reason_dropdown_option_id?.message}</p>}
              </div>

              <div className="column">
                <SpecialInstruction
                  content={"<span>" +
                    "<span class='has-text-weight-bold'>This will perform the following actions:</span><br>" +
                    "<span class='pl-2'>• Set origination status to payment_status_void</span><br>" +
                    "<span class='pl-2'>• Set all outstanding payments to payment_status_void</span><br>" +
                    "<span class='pl-2'>• Remove payments.payment_batch_id</span><br>" +
                    "<span class='pl-2'>• Set loan status to loan_status_void</span><br>" +
                    "</span>"}
                  type="is-warning"
                />
              </div>
            </div>
          </section>
          <footer className="modal-card-foot is-justify-content-end py-1">
            <div className="lox-form__buttons-wrapper has-text-right">
              <button type="button" className="button is-small has-background-grey has-text-white" onClick={handleCancel}>Cancel</button>
              <button type="submit" className="button is-danger is-small" disabled={saving && 'disabled'}>{saving ? 'Submitting' : 'Void Loan'}</button>
            </div>
          </footer>
        </div>
      </div>
    </form>
  ) : null;
}
